import { useTopNavigationLinks } from "hooks/layout"
import { useHistory } from "react-router-dom"

export function useReportsTopNavigationLinks() {
  const history = useHistory()

  useTopNavigationLinks([
    {
      label: 'DETAILED',
      urlMatcher: "/reports$",
      onClick: () => { 
        history.push("/reports")
       },
    },
    {
      label: 'SAVED',
      urlMatcher: "/reports/saved",
      onClick: () => { 
        history.push('/reports/saved')
      }
    }
  ])
}